import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\GetUserActivitiesByIdController::__invoke
* @see app/Http/Controllers/User/GetUserActivitiesByIdController.php
* @route '/api/user/{user}/activities'
*/
const GetUserActivitiesByIdController = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUserActivitiesByIdController.url(args, options),
    method: 'get',
})

GetUserActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/user/{user}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\GetUserActivitiesByIdController::__invoke
* @see app/Http/Controllers/User/GetUserActivitiesByIdController.php
* @route '/api/user/{user}/activities'
*/
GetUserActivitiesByIdController.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return GetUserActivitiesByIdController.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\GetUserActivitiesByIdController::__invoke
* @see app/Http/Controllers/User/GetUserActivitiesByIdController.php
* @route '/api/user/{user}/activities'
*/
GetUserActivitiesByIdController.get = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUserActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\GetUserActivitiesByIdController::__invoke
* @see app/Http/Controllers/User/GetUserActivitiesByIdController.php
* @route '/api/user/{user}/activities'
*/
GetUserActivitiesByIdController.head = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetUserActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetUserActivitiesByIdController